<template>
  <v-layout class="mt-5">
    <v-flex>
      <v-layout v-for="(product, index) in filteredProducts" :key="index" class="py-2">
        <v-flex xs12>
          <v-product-card :product="product" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

import VProductCard from "./ProductCard.vue";

export default {
  components: {
    VProductCard
  },
  computed: {
    ...mapGetters('ner', ['filteredProducts'])
  }
};
</script>